var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7668_2277)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2104 10.4212C14.2104 10.9444 14.6346 11.3685 15.1578 11.3685C15.681 11.3685 16.1051 10.9444 16.1051 10.4212V9.4738H17.0525C17.5757 9.4738 17.9999 9.04965 17.9999 8.52643C17.9999 8.00321 17.5757 7.57906 17.0525 7.57906H16.1051V6.63169C16.1051 6.10848 15.681 5.68433 15.1578 5.68433C14.6346 5.68433 14.2104 6.10848 14.2104 6.63169V7.57906H13.263C12.7398 7.57906 12.3157 8.00321 12.3157 8.52643C12.3157 9.04965 12.7398 9.4738 13.263 9.4738H14.2104V10.4212Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89474 4.26316C1.89474 1.90866 3.8034 0 6.15789 0C8.51239 0 10.4211 1.90866 10.4211 4.26316C10.4211 6.61765 8.51239 8.52632 6.15789 8.52632C3.8034 8.52632 1.89474 6.61765 1.89474 4.26316Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.2105C0 12.2742 1.16375 10.5164 2.90132 9.79939C3.14365 9.69963 3.40285 9.72038 3.64149 9.82895C4.50928 10.224 5.32876 10.4211 6.15789 10.4211C6.98987 10.4209 7.80651 10.2342 8.64474 9.85851C8.88688 9.75032 9.17081 9.75354 9.41447 9.85851C11.1456 10.6046 12.3158 12.3198 12.3158 14.2105V16.1053C12.3158 16.6285 11.8917 17.0526 11.3684 17.0526H0.947368C0.424137 17.0526 0 16.6285 0 16.1053V14.2105Z",
    fill: "#969696"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7668_2277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendMenu);
export default __webpack_public_path__ + "static/media/Friend-menu.bc0b49366945bfa2cdc3a3910cd19473.svg";
export { ForwardRef as ReactComponent };